import type { PublicSlotKey } from '#packages/apilib';
import type { AIAssistantApi } from './aiAssistantAPI';

export const AIAssistantApiKey: PublicSlotKey<AIAssistantApi> = {
  name: 'AIAssistantApi',
  public: true,
};
